import styled, { css } from 'styled-components';

// 버튼 변형 타입 정의
export type ButtonColor = 'primary' | 'green' | 'outline' | 'cancel';
export type ButtonSize = 'small' | 'medium' | 'large';

interface BaseButtonProps {
  text: string;
  variant?: ButtonColor;
  size?: ButtonSize;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
}

// 변형별 스타일 정의
const colorStyles = {
  primary: css`
    background-color: #d4ea2f;
    color: #0f0f0f;
    border: none;
  `,
  green: css`
    background-color: #002400;
    color: #fff;
    border: none;
  `,
  outline: css`
    background-color: #ffffff;
    color: #636a70;
    border: 1px solid #d2d3d6;
  `,
  cancel: css`
    background-color: #ffffff;
    color: #e43a35;
    border: 1px solid #e43a35;
  `,
};

// 크기별 스타일 정의
const sizeStyles = {
  small: css`
    height: 36px;
    padding: 8px 18px;
    font-size: 15px;
    font-weight: 400;
  `,
  medium: css`
    height: 48px;
    padding: 12px 24px;
    font-size: 15px;
    font-weight: 400;
    line-height: 24px;
  `,
  large: css`
    height: 56px;
    padding: 16px 24px;
    font-size: 16px;
    font-weight: 400;
  `,
};

const StyledButton = styled.button<{
  $variant: ButtonColor;
  $size: ButtonSize;
  $disabled?: boolean;
}>`
  width: 100%;
  border-radius: 4px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  white-space: nowrap;
  cursor: ${(props) => (props.$disabled ? 'not-allowed' : 'pointer')};
  line-height: 120%;

  ${(props) => colorStyles[props.$variant as ButtonColor]}
  ${(props) => sizeStyles[props.$size as ButtonSize]}


  &:disabled {
    background-color: #eaebef;
    color: #b6bcbf;
    cursor: not-allowed;
    border: none;
  }
`;

export const BaseButton = ({
  text,
  variant = 'primary',
  size = 'large',
  onClick,
  disabled = false,
}: BaseButtonProps) => {
  return (
    <StyledButton
      $variant={variant}
      $size={size}
      onClick={onClick}
      disabled={disabled}
      $disabled={disabled}
    >
      {text}
    </StyledButton>
  );
};
